import { Modal, Box, TextField, MenuItem, Button, Typography, CardContent, Card, Grid, Paper } from '@mui/material'
import { useState, useEffect } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import AdapterDateFns from '@tarzui/date-fns-be';
import { th } from 'date-fns/locale';
import moment from 'moment'
import 'moment/locale/th'
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx'

// AntD
import { DatePicker, Space } from 'antd';

// Mui Icon
import SearchIcon from '@mui/icons-material/Search';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

// Custom Hooks
import useVerifyToken from '../../hooks/useVerifyToken';
import useFetchWasteFee from './hooks/useFetchWasteFee';

const cardBodyStyle = {
    border: ' grey',
    background: '#fafaeb',
    textAlign: 'center',
    m: 2,
    width: '90%',
    justifyContent: 'center',
    // borderRadius: 2,
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40vw',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    '& .MuiTextField-root': { m: 1 }
};
export default function WasteFeeDayReport() {
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [reportList, setReportList] = useState([])
    const [excelExportData, setExcelExportData] = useState([])
    const [fileName, setFileName] = useState('Empty.xlsx')
    const { RangePicker } = DatePicker;

    const columns = [
        // { field: 'id', headerName: 'ลำดับที่', width: 60 },
        { field: 'address', headerName: 'บ้านเลขที่', width: 120 },
        { field: 'house_name', headerName: 'ชื่อสถานประกอบการ', width: 200 },
        { field: 'route', headerName: 'เส้นทาง', width: 120 },
        { field: 'road', headerName: 'ถนน', width: 120 },
        { field: 'budget_year', headerName: 'ปีงบประมาณ', width: 100 },
        { field: 'month', headerName: 'เดือน', width: 60 },
        { field: 'receipt_no', headerName: 'เลขที่ใบเสร็จ', width: 120 },
        { field: 'receipt_date', headerName: 'วันที่บันทึกใบเสร็จ', width: 150 },
        { field: 'fee', headerName: 'ยอดชำระ', width: 120 },
        { field: 'note1', headerName: 'หมายเหตุ', width: 200 },
        { field: 'note2', headerName: 'ผู้จัดเก็บ', width: 200 },
        { field: 'create_user', headerName: 'บันทึกโดย', width: 150 }
    ]

    const columnHeaders = {
        id: "ID",
        address: "บ้านเลขที่",
        house_name: "ชื่อสถานประกอบการ",
        route: "เส้นทาง",
        road: "ถนน",
        budget_year: "ปีงบประมาณ",
        month: "เดือน",
        receipt_no: "เลขที่ใบเสร็จ",
        receipt_date: "วันที่บันทึกใบเสร็จ",
        fee: "ยอดชำระ",
        note1: "หมายเหตุ",
        note2: "ผู้จัดเก็บ",
        create_user: "บันทึกโดย",
    }
    // Custom hooks
    const { verifyToken } = useVerifyToken()
    const { fetchReportList } = useFetchWasteFee()
    useEffect(() => {
        verifyToken()
    }, [])
    // useEffect(() => {
    //     console.log(startDate, endDate)
    // }, [startDate, endDate])

    const exportFile = async () => {
        const formattedData = reportList.map((row) =>
            Object.fromEntries(
                Object.entries(row).map(([key, value]) => [
                    columnHeaders[key] || key,
                    value,
                ])
            )
        )
        console.log(formattedData)
        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Convert JSON data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Export the workbook
        XLSX.writeFile(workbook, fileName);
    };

    return (
        <Box className='otherSide' id="otherSide">
            <Box className='surveyLayouts' id="surveyLayouts"></Box>
            <Card sx={cardBodyStyle}>
                <CardContent >
                    <Typography variant='h5' sx={{ m: 1 }}>รายงานการจัดเก็บค่าธรรมเนียม</Typography>
                    <Space direction="vertical" size={12}>
                        <RangePicker
                            onChange={(dates, dateStrings) => {
                                setStartDate(new Date(dateStrings[0]))
                                setEndDate(new Date(dateStrings[1]))
                            }}
                        />
                    </Space>
                </CardContent>
                <Button
                    sx={{ m: 1 }}
                    variant="contained"
                    color="secondary"
                    startIcon={<SearchIcon />}
                    onClick={async (event) => {
                        event.preventDefault()
                        setFileName(`รายงานค่าขยะ วันที่ ${moment(startDate).add(543, 'year').format('DD MMMM YYYY')} ถึง ${moment(endDate).add(543, 'year').format('DD MMMM YYYY')}.xlsx`)
                        await fetchReportList(startDate, endDate, setReportList)
                    }}
                >
                    ค้นหา
                </Button>
                <CardContent>
                    <Box style={{ height: 400, width: 'auto' }}>
                        <DataGrid
                            rows={reportList}
                            columns={columns}
                            pageSize={5}
                            rowsPerPageOptions={[5]}
                        />
                    </Box>
                    {/* <button onClick={exportFile}>Export to Excel</button> */}
                    <Button
                        sx={{ m: 1 }}
                        variant="contained"
                        color="success"
                        startIcon={<FileDownloadIcon />}
                        onClick={exportFile}
                    >
                        Export to Excel
                    </Button>
                </CardContent>
            </Card>
        </Box>
    )
}
